import React, { useState } from 'react'
import { exportPdf } from "../../../sharedfiles/pdfExport";
import ReportsTable from "../../Common/table/ReportsTable";

function ReferFriendTable(props) {
    const { dates } = props;
    const [fileType, setFileType] = useState("");


    const headers = [
        [
            "User ID",
            "Number of Referrals",
            "Users Registered",
            "Number of Conversions",
        ],
    ];
    const data = props.reportsData &&
        Array.isArray(props?.reportsData) &&
        props?.reportsData.length > 0 &&
        props?.reportsData?.map((item) => [
            item.referrerId,
            item.numberOfRegistrations,
            item.users,
            item.numberOfConversions,
        ]);

    const csvData =
        data && data.length > 0
            ? [...headers, ...data]
            : [];

    const title = props.reportPage;
    const subtitle = "Refer a Friend";
    const searchDate = {
        fromDate: dates.dateFrom,
        toDate: dates.dateTo,
    };

    const body =
        props.reportsData &&
            Array.isArray(props?.reportsData) &&
            props?.reportsData.length > 0
            ? data : [];
    const styles = {
        3: {
            valign: "middle",
            halign: "right",
        },
        4: {
            valign: "middle",
            halign: "right",
        },
    };
    const firstTable = {
        subtitle,
        headers,
        body,
        // styles,
        // alignments: ["3", "4"],
    };

    const tableData = [firstTable];
    const printPdf = () => {
        exportPdf(title, searchDate, tableData, styles);
    };

    return (
        <>
            <ReportsTable
                tableData={tableData}
                fileType={fileType}
                setFileType={(value) => setFileType(value)}
                csvData={csvData}
                fileName={title}
                printPdf={() => printPdf()}
            />
        </>
    );
};

export default ReferFriendTable
